<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الإهداء">
<h1><span dir="rtl">الإهداء</span></h1>
<p style="text-indent:0px;"><span dir="rtl">إلى الأحبَّاء الذين يدخلون حياتنا، ونعتاد على امتلاكهم، ويصبح وجودهم أمرًا مفروغًا منه، وإلى كلِّ الذِّكريات المنسيَّة.</span></p><br/>
<p style="text-indent:0px;"><span dir="rtl">إلى ساشا وراؤول، فلولاهما ولولا خوفي عليهما لما استطعتُ ترجمة أحاسيس الأمومة.</span></p><br/>
<p style="text-indent:0px;"><span dir="rtl">إلى مكاني السعيد "رويز"، حيث أجد الدِّفء والقهوة والكثير مِن الفرح والموسيقى.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?9459f034